import { render, staticRenderFns } from "./Integracao.vue?vue&type=template&id=7da52020"
import script from "./Integracao.vue?vue&type=script&lang=js"
export * from "./Integracao.vue?vue&type=script&lang=js"
import style0 from "./Integracao.vue?vue&type=style&index=0&id=7da52020&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports